// extracted by mini-css-extract-plugin
export default {"ldsSpinner":"Spinner_ldsSpinner__439Yq","lds-spinner":"Spinner_lds-spinner__kN7Tr"};